import React from 'react';
import cd from 'debug';
import { API, View } from '@gin-betting/core';

import { MarketTitle } from 'components';
import { TITLES_BY_SPECIFIER } from 'app-constants';
import { MarketTotalRow } from '../MarketTotalRow';
import useUserMarket from './useUserMarket';
import useRemoveUserMarkets from './useRemoveUserMarkets';
import './MarketTotal.scss';
import { getTotalSpecifier } from '../MarketsValue/utils';

const debug = cd('match-list:components:MarketTotal');

export interface OwnProps {
    market: View.Market;
    hasMatchHeader?: boolean;
    // matchId: string;
    // getCustomMarketMatches: () => void;
    isDefaultName?: boolean;
}

type Props = OwnProps;

const MarketTotal: React.FC<Props> = props => {
    debug('render', props);
    const {
        market,
        hasMatchHeader,
        // getCustomMarketMatches,
        // matchId,
        isDefaultName,
    } = props;

    const { id: topMarketId } = market;
    const userMarket = useUserMarket({ topMarketId });
    const resultMarket = userMarket || market;

    const {
        id,
        specifiers,
        name,
        // typeId
    } = resultMarket;

    const specifier = getTotalSpecifier(specifiers);
    const specifierValue = specifier ? specifier.value : '';

    // useRemoveUserMarkets(topMarketId);

    return (
        <div styleName="container" className="__app-MarketTotal-container">
            {hasMatchHeader && (
                <MarketTitle
                    name={isDefaultName ? '' : name}
                    defaultMsg={TITLES_BY_SPECIFIER.total}
                />
            )}
            <MarketTotalRow
                // matchId={matchId}
                // topMarketId={topMarketId}
                selectedMarketId={id}
                // marketType={typeId}
                // getCustomMarketMatches={getCustomMarketMatches}
                value={specifierValue}
            />
        </div>
    );
};

const defaultProps: Required<Pick<Props, 'market'>> = {
    market: {
        id: '',
        priority: 0,
        status: API.MarketStatus.SUSPENDED,
        odds: ['', ''],
        name: '',
        specifiers: [],
        typeId: -999,
        tags: [],
    },
};

MarketTotal.defaultProps = defaultProps;

export default MarketTotal;
